import request from '@/utils/request'

const API_PREFIX = '/uni/shopping';

// 获取依据商品分类查询商品列表
export function getShoppingCategoryList(data) {
    return request({
        url:  `${API_PREFIX}/category/list`,
        method: 'post',
        data
    })
}
// 获取依据商品分类查询商品列表
export function getShoppingList(query, pageReq) {
    return request({
        url:  `${API_PREFIX}/list`,
        method: 'post',
        data: query,
        params: pageReq
    })
}

export function getShoppingDetail(id) {
    return request({
        url:`${API_PREFIX}/code/` + id,
        method: 'get'
    })
}

export function getShoppingDetailId(id) {
    return request({
        url:`${API_PREFIX}/` + id,
        method: 'get'
    })
}

export function getShoppingAttlist(data) {
    return request({
        url:`${API_PREFIX}/proAtt/list`,
        method: 'post',
        data
    })
}

// 获取商城页面文本内容
export function getShoppingMallByOne(data) {
    console.log('调用getShoppingMallByOne，请求参数:', data)
    console.log('请求URL:', `${API_PREFIX}/data/byOne`)
    return request({
        url: `${API_PREFIX}/data/byOne`,
        method: 'post',
        data
    })
}
